import { Product } from '@core/models';

/**
 * `stock` en `null` significa "sin seguimiento de existencias": servicios y combos, o un
 * bien cuyo inventario no pudo consultarse. Nunca es lo mismo que cero, así que se pregunta
 * por estos helpers en vez de comparar el número suelto.
 */
export function isSoldOut(product: Pick<Product, 'stock'>): boolean {
  return product.stock !== null && product.stock <= 0;
}

/** Unidades que quedan, o `null` si la tienda no lleva existencias de este ítem. */
export function stockLeft(product: Pick<Product, 'stock'>): number | null {
  return product.stock !== null && product.stock > 0 ? product.stock : null;
}
